import React, { PureComponent } from 'react'
import injectSheet from 'react-jss'
import cx from 'classnames'
import NativeStepper from './NativeStepper'
import styles from '../assets/styles/components/OptionStepper'
import { STEPPER_MAX } from '../constants/app'

class OptionStepper extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      itemQantity: 0,
    }
  }

  handleOptionStepperOnChange = (stepperValue) => {
    const {
      stepperOnChange,
      item,
      groupName,
      groupId,
      dishId,
      inputType,
    } = this.props

    const isIncrementQty = (stepperValue > this.state.itemQantity)

    this.setState({
      itemQantity: stepperValue,
    }, () => {
      const itemQty = this.state.itemQantity
      item.stepperValue = itemQty
      stepperOnChange(item, groupName, groupId, dishId, inputType, isIncrementQty)
    })
  }

  render () {
    const {
      classes,
      item,
      isDisabled,
      isDisabledIncreaseBtn,
    } = this.props

    const wrapStyle = cx(classes.wrap)

    return (
      <div className={wrapStyle}>
        <NativeStepper
          value={this.state.itemQantity}
          max={isDisabledIncreaseBtn ? this.state.itemQantity : (item.max || STEPPER_MAX)}
          disabled={!!isDisabled}
          onMinusClick={(newValue) => this.handleOptionStepperOnChange(newValue)}
          onPlusClick={(newValue) => this.handleOptionStepperOnChange(newValue)}
        />
      </div>
    )
  }
};

export default injectSheet(styles)(OptionStepper)



// WEBPACK FOOTER //
// ./src/components/OptionStepper.js